<template>
<div class="shareCommon2_ui">
    <div class="share-dialog-main" ref="poster">
        <div class="download-wrap">

            <div class="main-img-wrap">
                <img class="main-img" :src="shareConfig.mainPicUrl+'?imageView2/1/w/750/h/1000/q80/format/webp'" />

            </div>
            <div class="main-info">
                <div class="time-box">
                    <div class="time">活动时间：{{shareConfig.info1.time}}</div>
                </div>
                <div class="info-container">
                    <div class="info-main">
                        <div class="title" id="title-box">
                            <div id="title">
                                {{shareConfig.info1.name}}
                            </div>

                        </div>
                        <div class="tl-name">{{shareConfig.info1.title}}</div>

                    </div>
                    <div class="qrcode-wrap">
                        <div class="qrcode" id="qrcode">
                          <img :src="qrCode" v-if="qrCode">
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <transition name="slide-fade">
        <div class="poster-box" v-show="isPoster&&posterImg!=''">
            <div class="posterImg">
                <div class="close" @click="closePoster()">
                    <i class="iconfont iconcha"></i>
                </div>
                <img :src="posterImg" />
            </div>
        </div>
    </transition>
</div>
</template>

<script>
var config = {};
import api from "@/utils/api";
import {
    jAlert3
} from "@/base/jAlert/jAlert";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import {
    getStorage
} from "@/utils/wxuser";
import { miniProgram } from "@/utils/miniProgram";
export default {
    data() {
        return {
            wxuser: getStorage("wxuser"),
            qrCode: "",
            posterImg: "",
            isPoster: false,
        };
    },
    props: {
        shareConfig: {
            type: Object,
        },
        hasConfigSKU: {
            type: Boolean,
        },
    },
    watch: {
        isPoster(val) {
            if (this.posterImg == "" && val) {
                this.$store.dispatch("openLoading", "加载中...");
            }
        },
    },
    methods: {
        closePoster() {
            this.isPoster = false;
            // this.$emit("close");
        },
        shotPic() {
            html2canvas(this.$refs.poster, {
                useCORS: true,
                // allowTaint: true
            }).then((canvas) => {
                // document.body.appendChild(canvas);
                this.$nextTick(() => {
                    let dataURL = canvas.toDataURL("image/png");
                    this.posterImg = dataURL;
                    this.$store.dispatch("closeLoading");
                });
            });
        },
        ellipsis() {
            var $container = document.getElementById("title-box");
            var $content = document.getElementById("title");
            var str = $content.innerHTML;
            console.log($content.offsetHeight, $container.offsetHeight)
            if ($content.offsetHeight >= $container.offsetHeight) {
                for (var i = 0; i <= str.length; i++) {
                    $content.innerHTML = str.slice(0, i)
                    if ($content.offsetHeight > $container.offsetHeight) {

                        $content.innerHTML = str.slice(0, i - 4) + "..."
                        console.log($content.innerHTML)
                        break;
                    }
                }
            }
        },
        async getShortUrl() {
            var opt = {
                longUrl: this.shareConfig.url,
                appid: config.appid,
                componentAppid: config.componentAppid,
            };
            // this.$store.dispatch("openLoading", "加载中...");
            var codeW = 80;
            var res = await api.getShortUrl(opt)
            if (res.result == 1) {
                var isMiniProgram = await miniProgram.isMiniProgram();
                if (isMiniProgram) {
                    var obj = {
                        hotelCode: config.hotelCode,
                        hotelGroupCode: config.hotelGroupCode,
                        scene: res.retVal,
                        appid: config.miniAppid,
                        componentAppid: config.componentAppid,
                        line_color_g: 0,
                        page: 'pages/mall/webview',
                        width: 500,
                        line_color_b: 0,
                        auto_color: false,
                        is_hyaline: true,
                        line_color_r: 0,
                    }
                    api.getWxacodeUnlimitUrl(obj).then(res => {
                        this.qrCode = res.retVal.imageUrl + '?imageMogr2/thumbnail/150x'
                        this.$nextTick(() => {
                            this.shotPic();
                        })
                    })
                } else {
                    this.$nextTick(() => {
                        let qrcode = new QRCode("qrcode", {
                            width: codeW,
                            height: codeW,
                            text: res.retVal, // 二维码地址
                        });
                        this.shotPic();
                    });
                }

            } else {
                this.$nextTick(() => {
                    let qrcode = new QRCode("qrcode", {
                        width: codeW,
                        height: codeW,
                        text: this.shareConfig.url, // 二维码地址
                    });
                    this.shotPic();
                });
                this.$store.dispatch("closeLoading");
            }

        },
    },

    created() {

        config = getStorage("config");
    },
    mounted() {
        this.$nextTick(() => {
            this.ellipsis();
        })

        this.getShortUrl();
    },
};
</script>

<style lang="less">
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.shareCommon2_ui {
    width: 100%;
    overflow: hidden;

    .share-dialog-main {
        position: fixed;
        width: 10rem;
        background: #fff;
        overflow: hidden;
        box-sizing: border-box;
        left: 0;
        top: -100000px;
        z-index: -9;

        .main-img-wrap {
            .main-img {
                width: 100%;
                height: 13.333333rem;
            }
        }

        .main-info {
            padding: 0.4rem 0.4rem 0.533333rem 0.4rem;
            background-image: radial-gradient(50% 144%,
                    #e8c3a2 0%,
                    #e2bd96 0%,
                    #ad8356 100%);

            .time-box {
                background: #926c4b;
                border-radius: 0.426667rem;
                font-size: 14px;
                text-align: center;
                color: #ffffff;
                line-height: 0.8rem;

            }

            .info-container {
                display: flex;
                margin-top: 0.533333rem;
                 .qrcode-wrap {
                    box-sizing: border-box;
                    text-align: center;
                    padding-right: 0.266667rem;

                    .qrcode {
                        display: inline-block;
                        width: 2.133333rem;
                        height: 2.133333rem;
                        box-sizing: border-box;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .info-main {
                    flex: 1;
                    padding-right: 0.4rem;

                    .tl-name {
                        margin-top: 0.32rem;
                        font-family: PingFangSC-Regular;
                        font-size: 13px;
                        color: #ffffff;
                    }

                    .title {
                        font-family: PingFangSC-Semibold;
                        font-size: 18px;
                        color: #ffffff;
                        line-height: 0.693333rem;
                        height: 1.386667rem;
                    }
                }
            }
        }
    }

    .poster-box {
        z-index: 999;
        background: rgba(0, 0, 0, 0.5);
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;

        .posterImg {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);

            img {
                width: 75vw;
            }

            .close {
                color: #fff;
                width: 0.8rem;
                height: 0.8rem;
                background: rgba(0, 0, 0, 0.5);
                position: absolute;
                right: 0;
                top: 0;
                margin-right: -0.4rem;
                margin-top: -0.4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;

                i {
                    font-size: 14px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shareCommon2.vue